export default "__VITE_ASSET__r4yX$uG0__"